import axios from "axios";
import op from "../../../../modulos/datos";

class ComercioService {
  constructor() {
    this.token = localStorage.getItem("jwtToken");
    this.conexion = op.conexion;
  }

  getHeaders() {
    return {
      headers: {
        "x-access-token": `${this.token}`,
        "Content-Type": "application/json",
      },
    };
  }

  updateToken() {
    this.token = localStorage.getItem("jwtToken");
  }

  async getComercios() {
    try {
      const response = await axios.get(
        `${this.conexion}/api/industria/comercios`,
        this.getHeaders(),
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getTiposContribuyente() {
    try {
      const response = await axios.get(
        `${this.conexion}/api/industria/tiposcontribuyente`,
        this.getHeaders(),
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getConfiguracionIndustria() {
    try {
      const response = await axios.get(
        `${this.conexion}/api/industria/configuracionindustria`,
        this.getHeaders(),
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getStatus() {
    try {
      const response = await axios.get(
        `${this.conexion}/api/efiscal/status`,
        this.getHeaders(),
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getComercioPersona(idcomercio) {
    try {
      const response = await axios.get(
        `${this.conexion}/api/industria/comerciopersona/${idcomercio}`,
        this.getHeaders(),
      );
      console.log("consulta 1");
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getActividad(idactividad) {
    try {
      const response = await axios.get(
        `${this.conexion}/api/industria/actividad?idactividad=${idactividad}`,
        this.getHeaders(),
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getActividadxComercio(idcomercio, anio) {
    try {
      const response = await axios.get(
        `${this.conexion}/api/industria/actividadxcomercio?idcomercio=${idcomercio}&anio=${anio}`,
        this.getHeaders(),
      );
      console.log("consulta 2");
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getUsuarioWebxComercio(idcomercio) {
    try {
      const response = await axios.get(
        `${this.conexion}/api/industria/usuariowebxcomercio?idcomercio=${idcomercio}`,
        this.getHeaders(),
      );
      console.log("consulta 3");
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getInmueblexComercio(idinmueble) {
    try {
      const response = await axios.get(
        `${this.conexion}/api/industria/inmueblexcomercio?idinmueble=${idinmueble}`,
        this.getHeaders(),
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getDeudaComercio(idcomercio, fecha, espiritu, tipounid = 1) {
    try {
      const response = await axios.get(
        `${this.conexion}/api/industria/deudacomercio?idcomercio=${idcomercio}&fecha=${fecha}&espiritu=${espiritu}&tipounid=${tipounid}`,
        this.getHeaders(),
      );
      console.log("consulta 4");

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getPagosWebComercio(idcomercio) {
    try {
      const response = await axios.get(
        `${this.conexion}/api/industria/pagosWebComercio2?idComercio=${idcomercio}`,
        this.getHeaders(),
      );
      console.log("consulta 5");

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getRetencionesxAgente(idcomercio) {
    try {
      const response = await axios.get(
        `${this.conexion}/api/industria/retencionesxagente?idcomercio=${idcomercio}`,
        this.getHeaders(),
      );
      console.log("consulta 6");

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getMultas(idcomercio) {
    try {
      const camp =
        "idmulta, fechamulta, descripcion, concepto, monto, cancelada";
      const tabla = "multa";
      const nombreid = "idcontribuyente";
      const nombreid2 = "tablacontribuyente";
      const valorid2 = "comercio";
      const nombreid3 = "tipoimpuesto";
      const valorid3 = "ACTIVIDADES ECONOMICAS";

      const response = await axios.get(
        `${this.conexion}/api/consulta/modeli3string?campos=${camp}&id=${idcomercio}&nomtab=${tabla}&nomid=${nombreid}&nomid2=${nombreid2}&id2=${valorid2}&nomid3=${nombreid3}&id3=${valorid3}`,
        this.getHeaders(),
      );
      console.log("consulta 7");

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getFacturasPagadas(idcomercio) {
    try {
      const campos = "*";
      const nomtab = `seleccionar_facturas_pagadas_web(${idcomercio})`;
      const orden = "numfactura";
      const response = await axios.get(
        `${this.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`,
        this.getHeaders(),
      );
      console.log("consulta 8");

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getFactorCambio() {
    try {
      const response = await axios.get(
        `${this.conexion}/api/vehiculo/factorcambio`,
        this.getHeaders(),
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getAllComercioData(idcomercio, fecha, espiritu, anio) {
    try {
      const [
        comercioPersona,
        actividadxComercio,
        usuarioWeb,
        deuda,
        pagosWeb,
        retenciones,
        multas,
        facturasPagadas,
      ] = await Promise.all([
        this.getComercioPersona(idcomercio),
        this.getActividadxComercio(idcomercio, anio),
        this.getUsuarioWebxComercio(idcomercio),
        this.getDeudaComercio(idcomercio, fecha, espiritu),
        this.getPagosWebComercio(idcomercio),
        this.getRetencionesxAgente(idcomercio),
        this.getMultas(idcomercio),
        this.getFacturasPagadas(idcomercio),
      ]);

      let actividad = null;
      if (comercioPersona && comercioPersona.idactividad) {
        actividad = await this.getActividad(comercioPersona.idactividad);
      }

      let inmueble = null;
      console.log(comercioPersona);
      if (comercioPersona && comercioPersona.idinmueble) {
        inmueble = await this.getInmueblexComercio(comercioPersona.idinmueble);
      }

      return {
        comercio: comercioPersona,
        actividad,
        actividadxComercio,
        usuarioWeb,
        inmueble,
        deuda,
        pagosWeb,
        retenciones,
        multas,
        facturasPagadas,
      };
    } catch (error) {
      throw error;
    }
  }

  async resumenDeclaracion(tipo, fechaini, fechafin, mes, anio, espiritu, filtroTipo) {
    console.log('resumenDeclaracion', { tipo, fechaini, fechafin, mes, anio, espiritu, filtroTipo });
    try {
      const response = await axios.get(
        `${this.conexion}/api/industria/resumenDeclaracion?tipo=${tipo}&fechaini=${fechaini}&fechafin=${fechafin}&mes=${mes}&anio=${anio}&espiritu=${espiritu}&filtroTipo=${filtroTipo}`,
        this.getHeaders()
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getDeudaComercioRS(idcomercio, fecha, espiritu, tipounid = 1) {
    try {
      const response = await axios.get(
        `${this.conexion}/api/industria/deudacomerciors?idcomercio=${idcomercio}&fecha=${fecha}&espiritu=${espiritu}&tipounid=${tipounid}`,
        this.getHeaders(),
      );
      console.log("consulta deudacomerciors");
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getDeudaComercioUnificado(idcomercio, fecha, espiritu, tipounid = 1) {
    try {
      let endpoint;
      if (espiritu === 100) {
        endpoint = `${this.conexion}/api/industria/deudacomerciors?idcomercio=${idcomercio}&fecha=${fecha}&espiritu=${espiritu}&tipounid=${tipounid}`;
      } else {
        endpoint = `${this.conexion}/api/industria/deudacomercio?idcomercio=${idcomercio}&fecha=${fecha}&espiritu=${espiritu}&tipounid=${tipounid}`;
      }

      const response = await axios.get(endpoint, this.getHeaders());
      console.log("consulta deuda unificada", espiritu === 100 ? "RS" : "normal");
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new ComercioService();
